import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQuery } from './baseQuery';
import { IMarketplace } from '../../shared/models/sale/marketplace';

export const marketplaceApi = createApi({
  reducerPath: 'marketplaceApi',
  baseQuery,
  endpoints: (builder) => ({
    getMarketplaceList: builder.query<IMarketplace[], string>({
      query: (companyTaxId) => ({
        url: `/api/marketplaces/list?companyTaxId=${companyTaxId}`,
        method: 'GET',
      }),
    }),
  }),
});

export const { useLazyGetMarketplaceListQuery } = marketplaceApi;
